import KnowledgebaseContainer from "../../../Components/Miscellaneous/Knowledgebase/KnowledgebaseContainer";

const Knowledgebase = () => {
  return <KnowledgebaseContainer />;
};

export default Knowledgebase;
